




































































































































import { GeekItem, Skill } from '@/models';
import { GeekProfileGeneralPosition, RecentActivity } from '@/models/dashboard';
import {
  LatestAccomplishmentMetadata,
  LatestAccomplishmentType,
  OneOfLatestAccomplishments,
  OpportunitiesCount,
  } from '@/models/geek-profile';
import { buildGeekName } from '@/utils';
import { latestAccomplishmentMixin } from '@/shared';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import numeral from 'numeral';

export default mixins(latestAccomplishmentMixin).extend({
  name: 'GeekInfo',
  props: {
    opportunitiesCounterTile: Boolean,
    shareFeedbackTile: Boolean,
    latestAccomplishmentTile: Boolean,
    requestRewardTile: Boolean,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      loader: {
        areRecentActivitiesPending: false,
      },
      latestAccomplishment: {
        imageUrl: '',
        text: '',
      } as LatestAccomplishmentMetadata,
      latestAccomplishmentType: LatestAccomplishmentType,
    };
  },
  created() {
    this.fetchGeekInfo();
  },
  computed: {
    geekName(): string {
      return buildGeekName(this.geek);
    },
    latestGained(): OneOfLatestAccomplishments {
      return typedStore(this).state.history.latestAccomplishment;
    },
    geekBasicInfo(): GeekItem {
      return typedStore(this).state.geek.geek;
    },
    geekGeneralPosition(): GeekProfileGeneralPosition {
      return typedStore(this).state.scores.generalPosition;
    },
    opportunitiesCounter(): OpportunitiesCount {
      return typedStore(this).state.opportunities.opportunitiesCount;
    },
    geek(): GeekItem & GeekProfileGeneralPosition {
      return {...this.geekBasicInfo, ...this.geekGeneralPosition};
    },
    gxpTileText(): string {
      return this.$t(
        'dashboard.geek-info.gxp-text',
        {
          you: `<span>${this.$t('dashboard.geek-info.you')}</span>`,
          yourFriend: `<span>${this.$t('dashboard.geek-info.your-friend')}</span>`,
        },
      ) as string;
    },
    geekInfoText(): string {
      return this.$t(
        'dashboard.geek-info.jump-on',
        {
          gxpNumber: `<span>${this.geek.gxpToJumpOnNextPosition}</span>`,
          gxp: `<span>${this.$t('dashboard.geek-info.gxp')}</span>`,
          position: `<span>${numeral(this.geek.nextPosition).format('Oo')}</span>`,
          place: `<span>${this.$t('dashboard.geek-info.place')}</span>`,
        },
      ) as string;
    },
    isSomebodyToJumpOver(): boolean {
      return !!this.geek.nextPosition;
    },
  },
  methods: {
    async fetchGeekInfo() {
      this.loader.areRecentActivitiesPending = true;
      try {
        await Promise.all([
          this.$store.dispatch(Actions.history.fetchLatestAccomplishment),
          this.$store.dispatch(Actions.geek.fetchGeekBasicInfo),
          this.$store.dispatch(Actions.scores.fetchGeekGeneralPosition),
        ]);

        if (this.opportunitiesCounterTile) {
          await this.$store.dispatch(Actions.opportunities.fetchGeekOpportunitiesCount, this.geekBasicInfo.id);
        }
      } finally {
        this.loader.areRecentActivitiesPending = false;
      }
    },
    goToRewardGeek() {
      this.$router.push({name: 'reward-geek'});
    },
    goToAchievements() {
      this.goToTabWithParam('geek-achievements');
    },
    goToBadges() {
      this.goToTabWithParam('geek-badges');
    },
    goToActivities() {
      this.goToTabWithParam('geek-activities');
    },
    goToFeedback() {
      this.$router.push({name: 'feedback'});
    },
    goToOpportunities() {
      this.$router.push({name: 'opportunity'});
    },
    goToTabWithParam(tab: string) {
      this.$router.push({name: tab, params: { geekId: this.geek.id }});
    },
    buildGeekName,
  },
  watch: {
    latestGained() {
      this.refreshLatestAccomplishment();
    },
  },
});
